import { ADD_POINT, CLICK_SUBMIT_POLL, GET_POLL_ANSWER } from '../constants/ActionType';
import dayjs from 'dayjs';

export const onSubmitPoll = (id, answer) => {
  return {
    type: CLICK_SUBMIT_POLL,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    survey_id: id,
    answer: answer
  };
};
export const onAddingPoint = (id, point) => {
  return {
    type: ADD_POINT,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    survey_id: id,
    point: point
  };
};
export const getPollAns = (id) => {
  return {
    type: GET_POLL_ANSWER,
    timestamp: dayjs(new Date().getTime()).format('HH:mm:ss'),
    id: id
  };
};

// export const onViewAllClick = (con_type) => {
//   return {
//     type: ON_VIEW_ALL_BUTTON_CLICK,
//     timestamp: dayjs(new Date().getTime()).format("HH:mm:ss"),
//     contentType: con_type

//   }
// }
